import React from 'react';
import { buildLocationNameClasses } from '../../utils/locationName';

// Accepts either `type` (preferred) or `kind` (backward-compat)
// type/kind: 'country' | 'group' | 'custom-group' | null
export default function LocationName({ children, type, kind = 'country', className = '' }) {
	const classes = buildLocationNameClasses({ type, kind, className });
	return <span className={classes}>{children}</span>;
}
